import { styled } from '@styledComponents';
import { Box } from '@components/Box';
import { CloudImage } from '@components/CloudImage';
import { TextPairing } from '@components/TextPairing';
import { Columns, Column } from '@components/Columns';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';

export const WrapperBox = styled(Box)`
  overflow: visible;
  background: #fcfaf8;
  width: 100%;
  justify-content: center;
  position: relative;
  ${themeMediaQuery('below_sm')} {
    overflow: hidden;
  }
  ${themeMediaQuery('sm')} {
    overflow: visible;
  }
`;

export const StyledTextPairing = styled(TextPairing)`
  text-align: center;
  ${themeMediaQuery('below_sm')} {
    .text-pairing-title {
      width: 260px;
      margin: auto;
    }
  }
`;

export const StyledColumns = styled(Columns)`
  ${themeMediaQuery('below_sm')} {
    padding-left: ${themeSpace(6)};
    padding-right: ${themeSpace(6)};
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
`;

export const StyledColumn = styled(Column)`
  min-height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${themeMediaQuery('below_sm')} {
    min-height: initial;
  }
`;

export const TopColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    order: 2;
  }
`;

export const BottomColumn = styled(Column)`
  ${themeMediaQuery('below_sm')} {
    order: 1;
  }
`;

export const StyledCloudImage = styled(CloudImage)`
  width: 100%;
  border-radius: 50%;
`;

export const StyledBox = styled(Box)`
  text-align: left;
`;

export const ValueTextPairing = styled(TextPairing)`
  align-items: center;
  ${themeMediaQuery('below_sm')} {
    text-align: center;
  }
`;

export const TopBackground = styled(Box)`
  position: absolute;
  top: 0;
  right: 0;
  width: 30%;
`;

export const TopForeground = styled(Box)`
  position: absolute;
  top: -50px;
  right: 0;
`;

export const BottomBackground = styled(Box)`
  position: absolute;
  bottom: 0px;
  width: 35%;
  display: flex;
  ${themeMediaQuery('below_sm')} {
    width: 65%;
    bottom: 0px;
  }
  ${themeMediaQuery('sm')} {
    width: 55%;
  }
  ${themeMediaQuery('md')} {
    width: 45%;
  }
  @media (min-width: 1400px) {
    width: 35%;
  }
  ${themeMediaQuery('xl')} {
    width: 25%;
  }
`;

export const BottomForeground = styled(Box)`
  position: absolute;
  bottom: 600;
`;

export const MobileBottomForeground = styled(BottomForeground)`
  bottom: 0px;
  width: 65%;
`;
